/**
 * @file: serviceAgent.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */
import { orgUserRoleContains } from '@euler/functions/orgUserUtils';
import { SimpleOrgMember } from '@euler/model';
import { OrgUserRoleType } from '@euler/model/enum';
import { serviceFactory } from '@euler/services/factory';
import { Observable } from 'rxjs';
import { AbstractSearchCriterionProvider } from '../AbstractSearchCriterionProvider';
import { SearchCriterionOption } from '../types';

export class ServiceAgentCriterion extends AbstractSearchCriterionProvider<'serviceAgent'> {
  static readonly shared = new ServiceAgentCriterion();

  private _users: SimpleOrgMember[] | undefined;

  constructor() {
    super('serviceAgent');
  }

  getLabel(): string {
    return '服务顾问';
  }

  getOptions(): Observable<SearchCriterionOption<SimpleOrgMember>[]> {
    return new Observable(subscriber => {
      if (this._users != null) {
        subscriber.next(this.makeOptions(this._users));
      }
      // try to get the recent list of order tags.
      serviceFactory.storeService
        .getSimpleMemberList()
        .then(users => {
          this._users = users;
          subscriber.next(this.makeOptions(users));
          subscriber.complete();
        })
        .catch(err => {
          console.error(err);
          subscriber.next([]);
          subscriber.complete();
        });
    });
  }

  protected internalGetDisplayText(value: SimpleOrgMember): string {
    return value.name;
  }

  protected internalGetOptions(): SearchCriterionOption<SimpleOrgMember>[] {
    throw new Error('Method not implemented.');
  }

  protected internalGetKey(value: SimpleOrgMember): string {
    return String(value.id);
  }

  private makeOptions(
    users: SimpleOrgMember[],
  ): SearchCriterionOption<SimpleOrgMember>[] {
    return [
      { value: undefined },
      ...users
        .filter(x => orgUserRoleContains(x.role, OrgUserRoleType.ServiceAgents))
        .map(user => ({
          value: user,
          text: user.name,
          image: user.avatar,
        })),
    ];
  }
}
